/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { CreateAdminCompetitionResponse, CreateAdminCompetitionVars } from '../openapi-types.gen.js';

export type { CreateAdminCompetitionResponse, CreateAdminCompetitionVars } from '../openapi-types.gen.js';

export const useCreateAdminCompetition = createMutationHook<CreateAdminCompetitionVars, CreateAdminCompetitionResponse, unknown>({
  specName: 'useCreateAdminCompetition',
  path: '/v1/admin/competitions',
  method: 'POST',
  resolveUrl: (vars: CreateAdminCompetitionVars) => `/v1/admin/competitions`,
  buildBody: (vars: CreateAdminCompetitionVars) => ({ title: vars.title, subtitle: vars.subtitle, board: vars.board, metric: vars.metric, start: vars.start, end: vars.end, timezone: vars.timezone, bannerImageUrl: vars.bannerImageUrl, prizePoolD6: vars.prizePoolD6, rules: vars.rules }),
  parseResponse: (raw: unknown): CreateAdminCompetitionResponse => raw as CreateAdminCompetitionResponse,
  optimistic: [{
    queryKey: ['admin', 'list'],
    apply: (prev: any, vars: CreateAdminCompetitionVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }],
  
  
});
